import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  csOptOut,
  csStartCollection,
  csStopCollection,
  isInternalEmail,
  isWardrobeRoute,
} from "./contentsquare";

// Narrows what Contentsquare records:
//
//   1. Internal @teamsunday.com staff are opted out permanently. The email only
//      arrives one GET /me round-trip after boot, so the first few seconds of a
//      staff member's first session are still captured — but the opt-out cookie
//      Contentsquare sets keeps every later visit from that browser out
//      entirely.
//   2. The wardrobe module is excluded per route. Collection stops on entering
//      an `isWardrobe` route and resumes on leaving it, so brand-store, catalog,
//      agency and settings pages still record within the same session.
export function useContentsquareGate() {
  const { pathname } = useLocation();
  const email = useSelector((state) => state.auth.user?.email);
  const optedOutRef = useRef(false);
  // The tag records by default once loaded, so the initial state is "collecting".
  const collectingRef = useRef(true);

  useEffect(() => {
    if (optedOutRef.current) return;
    if (!isInternalEmail(email)) return;
    optedOutRef.current = true;
    csOptOut();
  }, [email]);

  useEffect(() => {
    // An opt-out is permanent — never resume collection on top of it.
    if (optedOutRef.current) return;

    const shouldCollect = !isWardrobeRoute(pathname);
    if (shouldCollect === collectingRef.current) return;
    collectingRef.current = shouldCollect;

    if (shouldCollect) csStartCollection();
    else csStopCollection();
  }, [pathname, email]);
}
